import React, { Component } from "react";
import BackButton from "./BackButton";
import FolderIcon from "../../../assets/icons/folder.svg";
import CreateFolderModal from "../CreateFolderModal";
import "./UploadFolderStep2.css";
import { Row, Col } from "antd";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getRootUpload } from "../../../actions/AssetsRootUploadAction";
import { Spin } from "antd";
import {
  cleanDataBack,
  getExploreUpload
} from "../../../actions/AssetsExploreUploadAction";
import { updateMetadata } from "../../../actions/UploadFolderAction";
import EmptyFolders from "./EmptyFolders";
import { sendNotification } from "../../../utils";
import InfiniteScroll from "react-infinite-scroll-component";

const spinnerStyle = {
  textAlign: "center",
  background: "rgba(0, 0, 0, 0.05)",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0"
};

class UploadFolderStep2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateFolderModal: false,
      isFolderCreated: false,
      page_new: 1,
      folderSelect_state: null,
      scrollState: false
    };
  }

  componentDidMount() {
    const { workclient, root, folderList, breadcrumb } = this.props;
    this.props.cleanDataBack();
    if (folderList.length === 0) {
      this.props.getRootUpload(workclient, root);
      const folder = this.props.selectedFolderExplore;
      if (folder) {
        const foundFolder = this.props.bunkersData.find(x => x._id === folder);
        if (foundFolder) {
          this.addFolder(foundFolder);
          this.handleGetData(foundFolder);
        } else {
          if (breadcrumb.length !== 0) {
            const item = breadcrumb.find(x => x._id === folder);
            if (item) {
              this.addFolder({
                _id: item._id,
                name: item.name,
                tagProtocol: item.tagProtocol
              });
            }
          }
          this.handleGetData({ _id: folder });
        }
      }
    } else {
      this.handleGetData(folderList[folderList.length - 1]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.folderselect !== this.props.folderselect) {
      this.compoundPath();
    }
  }

  compoundPath() {
    const { folderList } = this.props;
    let path = "/";
    for (let i = 0; i < folderList.length; i++) {
      path += `${folderList[i].name}/`;
    }
    this.props.updateMetadata({
      route: path
    });
  }

  handleGetData = (folderselect, page) => {
    const { workclient } = this.props;
    const { page_new, folderSelect_state } = this.state;
    const limit_new = 20;
    if (folderselect) {
      this.setState({
        folderSelect_state: folderselect
      });
    }
    if (page) {
      this.setState({
        page_new: page
      });
      if (page === 1) {
        this.setState({
          scrollState: false
        });
      }
    }
    const folder_se = folderselect ? folderselect : folderSelect_state;
    const page_se = page ? page : page_new;
    this.props.getExploreUpload(
      workclient,
      folder_se._id,
      page_se,
      null,
      true,
      [],
      limit_new
    );
  };

  addFolder = folder => {
    const oldFolderList = this.props.folderList;
    oldFolderList.push(folder);
    this.props.updateMetadata({
      folderList: oldFolderList,
      folderselect: folder._id,
      tagsProtocol: folder.tagProtocol
    });
  };

  removeFolder() {
    const { workclient, root, folderList: oldFolderList } = this.props;
    oldFolderList.pop();
    let newFolderselectId = "";
    let newTagsProtocol = "";
    if (oldFolderList.length === 0) {
      this.props.getRootUpload(workclient, root);
      newFolderselectId = "";
      newTagsProtocol = "";
    } else {
      this.handleGetData(oldFolderList[oldFolderList.length - 1]);
      newFolderselectId = oldFolderList[oldFolderList.length - 1]._id;
      newTagsProtocol = oldFolderList[oldFolderList.length - 1].tagProtocol;
    }
    this.props.updateMetadata({
      folderList: oldFolderList,
      folderselect: newFolderselectId,
      tagsProtocol: newTagsProtocol
      // tagsProtocol: "Este es un nuevo protocolo de tags"
    });
  }

  render() {
    const {
      showCreateFolderModal,
      isFolderCreated,
      page_new,
      scrollState
    } = this.state;
    const {
      workclient,
      root,
      folderList,
      bunkersData,
      isFetching,
      exploreFetching,
      // exploreData,
      exploreDataBack,
      intl,
      route,
      folderselect,
      newColor
    } = this.props;

    const isRoot = route === "/";
    return (
      <div
        style={{
          width: "100%",
          height: 450,
          paddingLeft: "5%",
          paddingRight: "5%",
          paddingTop: "1%",
          paddingBottom: "1%"
        }}
      >
        {!isRoot && (
          <BackButton
            onPressed={() => {
              this.props.cleanDataBack();
              this.setState({
                page_new: 1,
                scrollState: false
              });
              this.removeFolder();
            }}
          />
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
          }}
        >
          <p
            style={{
              marginRight: "1.5%",
              marginTop: 15
            }}
          >
            {intl.formatMessage({ id: "upload-folder-s2-uploadto" })}
            <span
              style={{
                color: "#000"
              }}
            >
              {route}
            </span>
          </p>
          <button
            onClick={() => {
              this.setState({
                showCreateFolderModal: true
              });
            }}
            style={{
              width: 30,
              height: 30,
              borderRadius: 8,
              backgroundColor: isFolderCreated ? "#fff" : newColor,
              border: "none",
              margin: 0
            }}
          >
            <img
              src={FolderIcon}
              alt="Folder"
              style={{
                cursor: "pointer",
                width: 18,
                height: 18,
                color: isFolderCreated ? newColor : "#fff"
              }}
            />
          </button>
        </div>
        <div
          style={{
            height: 300,
            width: "100%",
            overflowY: "auto",
            overflowX: "hidden"
          }}
          id="scrollableDiv"
        >
          <InfiniteScroll
            dataLength={exploreDataBack.length}
            next={() => {
              if (!isRoot && exploreDataBack.length >= 20) {
                this.setState({
                  page_new: page_new + 1,
                  scrollState: true
                });
                this.handleGetData();
              }
            }}
            hasMore={true}
            loader={
              !isRoot &&
              exploreFetching &&
              scrollState && (
                <Spin style={{ width: "100%" }} spinning={exploreFetching} />
              )
            }
            scrollableTarget="scrollableDiv"
          >
            {isRoot && isFetching && (
              <div style={spinnerStyle}>
                <Spin spinning={isFetching} />
              </div>
            )}
            {isRoot && !isFetching && (
              <Row gutter={16} span={24} type={"flex"} style={{ margin: 0 }}>
                {bunkersData.map(e => {
                  return (
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={6}
                      key={e._id}
                      style={{
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        this.addFolder(e);
                        this.handleGetData(e);
                      }}
                    >
                      <div
                        className="square"
                        style={{
                          backgroundColor: newColor,
                          borderColor: newColor
                        }}
                      >
                        <div className="text-square">{e.name}</div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
            {!isRoot && exploreFetching && !scrollState && (
              <div style={spinnerStyle}>
                <Spin spinning={exploreFetching} />
              </div>
            )}
            {/* && exploreData */}
            {!isRoot && exploreDataBack.length !== 0 && (
              <Row gutter={16} style={{ margin: 0 }}>
                {exploreDataBack.map(e => {
                  const isFolder = e.type === "bunkey" || e.type === "folder";
                  return (
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={6}
                      key={e._id}
                      style={{
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        if (!isFolder) return;
                        if (!isRoot && exploreFetching) {
                          sendNotification(
                            "info",
                            intl,
                            intl.formatMessage({ id: "load_data_folder" })
                          );
                          return;
                        }
                        this.props.cleanDataBack();
                        this.addFolder(e);
                        this.handleGetData(e, 1);
                      }}
                    >
                      <div className={isFolder ? "square" : "square-file"}>
                        <div
                          className={
                            isFolder ? "text-square" : "text-square-file"
                          }
                        >
                          {e.name}
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
            {!isRoot && !exploreFetching && exploreDataBack.length === 0 && (
              <EmptyFolders />
            )}
            {isRoot && !isFetching && bunkersData.length === 0 && (
              <EmptyFolders />
            )}
          </InfiniteScroll>
        </div>
        <CreateFolderModal
          showCreateFolderModal={showCreateFolderModal}
          handleHiddenCreateFolderModal={() => {
            this.setState({
              showCreateFolderModal: false
            });
            if (folderList.length === 0) {
              this.props.cleanDataBack();
              this.props.getRootUpload(workclient, root);
            } else {
              this.props.cleanDataBack();
              this.handleGetData(folderList[folderList.length - 1]);
            }
          }}
          bunkerEnabled={isRoot}
          folderselect={folderselect}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    root: state.client.root,
    workclient: state.client.workclient,
    isFetching: state.assetsRootUpload.isFetching,
    bunkersData: state.assetsRootUpload.data,
    exploreFetching: state.assetsExploreUpload.isFetching,
    exploreData: state.assetsExploreUpload.data,
    exploreDataBack: state.assetsExploreUpload.dataBack,
    limit: state.assetsExploreUpload.limit,
    folderselect: state.uploadFolder.folderselect,
    folderList: state.uploadFolder.folderList,
    route: state.uploadFolder.route,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    selectedFolderExplore: state.app.selectedFolderExplore,
    breadcrumb: state.client.breadcrumb
  };
};

const mapDispatchToProps = {
  getRootUpload,
  getExploreUpload,
  updateMetadata,
  cleanDataBack
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderStep2))
);
